import { g as getDB, m as magicLink, u as user, l as link } from "../../../../chunks/index3.js";
import { and, eq, gte } from "drizzle-orm";
import { l as loginUser } from "../../../../chunks/auth.server.js";
import { redirect, error } from "@sveltejs/kit";
import { i as invalidateSession } from "../../../../chunks/auth.js";
import { l as valibot, V as VerificationSchema, T as ThemeSchema } from "../../../../chunks/valibot.js";
import "clsx";
import "@sveltejs/kit/internal";
import "../../../../chunks/exports.js";
import "../../../../chunks/utils.js";
import "../../../../chunks/client2.js";
import "ts-deepmerge";
import "../../../../chunks/formData.js";
import { s as superValidate, f as fail, a as setError, m as message } from "../../../../chunks/superValidate.js";
import "memoize-weak";
import "zod-to-json-schema";
import { s as sendVerificationMail } from "../../../../chunks/index5.js";
import { l as localizeHref } from "../../../../chunks/runtime.js";
const maskmail = (mail) => {
  const [name, domain] = mail.split("@");
  const half = Math.ceil(name.length / 2);
  return `${name.slice(0, half)}${"*".repeat(half)}@${domain}`;
};
const load = async (event) => {
  const { locals, params } = event;
  const db = getDB();
  if (locals.user && locals.user.temp === false) {
    redirect(302, localizeHref("/"));
  }
  const data = await db.select({
    mail: magicLink.email,
    key: magicLink.verification,
    expiresAt: magicLink.expiresAt
  }).from(magicLink).where(and(eq(magicLink.id, params.hash), gte(magicLink.expiresAt, /* @__PURE__ */ new Date()))).get();
  if (!data) {
    redirect(302, localizeHref("/login"));
  }
  const [verificationForm, resendForm] = await Promise.all([
    superValidate(valibot(VerificationSchema)),
    superValidate(valibot(ThemeSchema))
  ]);
  return {
    resendForm,
    verificationForm,
    mail: maskmail(data.mail),
    keyLength: data.key.length,
    expiresAt: data.expiresAt
  };
};
const actions = {
  resend: async (event) => {
    const { params } = event;
    const { hash } = params;
    const db = getDB();
    const form = await superValidate(event.request, valibot(ThemeSchema));
    if (!form.valid) {
      return fail(400, { form });
    }
    const data = await db.select({
      email: magicLink.email,
      key: magicLink.verification
    }).from(magicLink).where(and(eq(magicLink.id, hash), gte(magicLink.expiresAt, /* @__PURE__ */ new Date()))).get();
    if (!data) {
      redirect(302, localizeHref("/login"));
    }
    await sendVerificationMail(data.email, data.key, form.data.theme);
    return message(form, "Mail sent");
  },
  verify: async (event) => {
    const { locals, params, request } = event;
    const { hash } = params;
    const db = getDB();
    const form = await superValidate(request, valibot(VerificationSchema));
    if (!form.valid) {
      return fail(400, { form });
    }
    const user$1 = await db.select({
      id: user.id,
      temp: user.temp
    }).from(magicLink).innerJoin(user, eq(magicLink.userId, user.id)).where(
      and(
        eq(magicLink.id, hash),
        eq(magicLink.verification, form.data.key),
        gte(magicLink.expiresAt, /* @__PURE__ */ new Date())
      )
    ).get();
    if (!user$1) {
      setError(form, "key", "Key is invalid or expired");
      return fail(400, { form });
    }
    if (locals.user?.temp === false && locals.user?.id !== user$1.id) {
      error(401, "Logout to switch user");
    }
    if (user$1.temp === true) {
      await db.update(user).set({ temp: false }).where(eq(user.id, user$1.id)).run();
    } else if (locals.user?.id && locals.user.temp === true) {
      await db.update(link).set({ userId: user$1.id }).where(eq(link.userId, locals.user.id)).run();
      if (locals.session) {
        await invalidateSession(locals.session.id);
      }
      await db.delete(user).where(eq(user.id, locals.user.id)).run();
    }
    await db.delete(magicLink).where(eq(magicLink.id, hash)).run();
    await loginUser(event, user$1.id);
    redirect(302, localizeHref("/"));
  }
};
export {
  actions,
  load
};
